import "./MandOptionGroup.css";
import React from "react";

const MandOptionGroup = React.memo(
  ({
    index,
    singleGroup,
    selected,
    handleOptionChange,
    notSelectablePPOCodes,
    dependentConflictRules,
  }) => {
    return (
      <div className="OptionGroup__container" key={`mand-op-group-${index}`}>
        <h4 className="OptionGroup__title">{singleGroup["group"]}</h4>
        <div className="ButtonGroup__container">
          {singleGroup["options"].map((option, index) => {
            const isDisabled = notSelectablePPOCodes.includes(option?.code);
            const dependentOnCode =
              dependentConflictRules?.[option?.code]?.dependentOn;
            const conflictList =
              dependentConflictRules?.[option?.code]?.conflictsWith || [];

            return (
              <button
                key={`${index} - ${option?.code}`}
                className={`ButtonGroup__button${
                  selected[singleGroup["group"]]?.code === option?.code
                    ? " active"
                    : ""
                }${isDisabled ? " disabled" : ""}`}
                onClick={() => handleOptionChange(singleGroup["group"], option)}
                disabled={isDisabled}
              >
                {option?.name}
                {dependentOnCode && (
                  <>
                    <br />
                    <span
                      style={{
                        color:
                          selected[singleGroup["group"]]?.code === option?.code
                            ? "gainsboro"
                            : "grey",
                        fontStyle: "italic",
                        fontWeight: "normal",
                        textTransform: "none",
                      }}
                    >
                      Only available with{" "}
                      {dependentConflictRules?.[dependentOnCode]?.name ||
                        dependentOnCode}
                    </span>
                  </>
                )}
                {conflictList.length > 0 && (
                  <>
                    <br />
                    <span
                      style={{
                        color:
                          selected[singleGroup["group"]]?.code === option?.code
                            ? "gainsboro"
                            : "grey",
                        fontStyle: "italic",
                        fontWeight: "normal",
                        textTransform: "none",
                      }}
                    >
                      Unavailable with{" "}
                      {conflictList
                        .map(
                          (single) =>
                            dependentConflictRules?.[single]?.name || single,
                        )
                        .join(", ")}
                    </span>
                  </>
                )}
              </button>
            );
          })}
        </div>
      </div>
    );
  },
);

export default MandOptionGroup;
